import type { TrackingEvent } from '@seek/hirer-promo-codes-banner';
import { useCallback } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { PromoCodeBannerConnectedCart } from 'src/app/shared/components/PromoCodeBannerConnectedCart';
import getTrackingAdapter from 'src/app/v1/dataAnalytics';
import type { AppState } from 'src/types/appState';

export const PromoCodeBanner = () => {
  const { draftId } = useSelector(
    (state: AppState) => ({
      draftId: state.session.draftId,
    }),
    shallowEqual,
  );

  const onTrackingCallback = useCallback((eventData: TrackingEvent) => {
    getTrackingAdapter.sendLinkEvent(eventData);
  }, []);

  return (
    <PromoCodeBannerConnectedCart
      draftId={draftId}
      onTrackingCallback={onTrackingCallback}
    />
  );
};
